export const ECurrencyDisplay = {
	NARROW_SYMBOL: 'narrowSymbol',
	CODE: 'code',
} as const;

export const ENumberFormatStyle = {
	CURRENCY: 'currency',
} as const;
